import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthApiService } from '@p2p/auth/api';
import { UserRole } from '@p2p/users/domain';
import { delay, filter, of } from 'rxjs';

@Component({
    selector: 'app-fallback-routing',
    template: `
        <div class="fallback-routing">
            <div class="fallback-routing__content">
                <lib-progress-overlay></lib-progress-overlay>
            </div>
        </div>
    `,
    styles: `
        .fallback-routing {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
        }

        .fallback-routing__content {
            width: 100%;
            height: 100%;
            position: relative;
        }
    `
})
export class FallbackRoutingComponent implements OnInit {
    private readonly authApiService = inject(AuthApiService);
    private readonly router = inject(Router);
    private readonly dr = inject(DestroyRef);

    ngOnInit(): void {
        this.authApiService.account$
            .pipe(
                filter((account) => !!account),
                takeUntilDestroyed(this.dr)
            )
            .subscribe((account) => {
                if (account.role === UserRole.AccountManager || account.role === UserRole.AccountManagerTrusted) {
                    this.router.navigateByUrl('/users');

                    return;
                }

                this.router.navigateByUrl('/dashboards');
            });

        of(null)
            .pipe(delay(8000), takeUntilDestroyed(this.dr))
            .subscribe(() => {
                this.router.navigateByUrl('/authorization');
            });
    }
}
